import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../../../components/Common/Actions";
import FilledButton from "../../../../components/Common/Buttons/FilledButton";
import CommonFilterModal from "../../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../../components/Common/TabBar";
import ListPageLayout from "../../../../components/Layout";
import Deletepopup from "../../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../../components/Utils/hooks/useSortHandler";
import {
  CommonTabBreadcrumbs,
  CommonTabnavBarData,
  statuses,
} from "../../Utils/MasterConst";

const timings = [
  "1:00 PM to 2:00 PM",
  "12:30 PM to 03:00 PM",
  "03:00 PM to 05:30 PM",
  "05:30 PM to 07:00 PM",
  "06:00 AM to 06:30 PM	",
  "05:30 AM to 06:00 PM",
];
const Timings = () => {
  const navigate = useNavigate();
  const addNewTimings = {
    id: "addnewpost",
    onClick: () => navigate("/master-timings-create"),
    style: { width: "240px" },
    label: "Add New Timings",
  };
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Filter states
  const [selectedValues, setSelectedValues] = useState({
    Timings: [],
    Status: [],
  });
  const [filteringKey, setFilteringKey] = useState([]);
  const [tempSelectedValues, setTempSelectedValues] = useState({
    Timings: [],
    Status: [],
  });

  const [selectedCategory, setSelectedCategory] = useState("Timings");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  const [loader, setLoader] = useState(true);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}timings/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler("timings", fetchData, setShowDelete);

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search, selectedValues]);
  useEffect(() => {
    const getFilterOptions = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}timings/getarray`,
        );
        setFilteringKey(res.data);
      } catch (err) {
        console.error(err);
        alert("Error loading filter options");
      }
    };
    getFilterOptions();
  }, []);
  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Timings",
      dataIndex: "type",
      width: 250,
      key: "type",
    },
    {
      title: "Status",
      dataIndex: "active",
      width: 150,
      key: "active",
      render: (active) => (active ? "Verified" : "Not Verified"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <Actions
            isEdit={true}
            isDelete={true}
            isView={true}
            onClickView={() => navigate(`/master-timing-view/${record._id}`)}
            onClickDelete={() => {
              setDeleteId(record._id);
              setShowDelete(true);
            }}
            onClickEdit={() => navigate(`/master-timing-edit/${record._id}`)}
          />
        </div>
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  const filters = {
    Timings: filteringKey,
    Status: statuses,
  };

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={<CommonTabBreadcrumbs last="Timings" />}
      addButton={<FilledButton props={addNewTimings} />}
      titles={<NavBarTitles titles={CommonTabnavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => setIsFilterModalVisible(true)}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={() => {
          setSelectedValues(tempSelectedValues);
          setIsFilterModalVisible(false);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        onReset={() => {
          setTempSelectedValues({ Timings: [], Status: [] });
          setSelectedValues({ Timings: [], Status: [] });
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />
    </ListPageLayout>
  );
};

export default Timings;
